@import 'styles/mixins';
@import 'styles/variables';

.wrap {
  display: flex;
  flex-direction: column;
  min-height: 36px; // Approx 1 line.
  transition: all 0.2s ease-in-out;
  padding: 0px;

  .input {
    @include thinScrollbar;
    overflow-y: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    > div {
      flex-grow: 1;

      > p {
        margin-top: 2px !important;
        margin-bottom: 0px !important;

        :global(img.ProseMirror-separator) {
          margin-top: -16px !important;
        }
      }
    }

    &.empty {
      > div {
        > p {
          align-items: flex-start;
          margin-top: 4px;
        }
      }
    }
  }

  &.focused {
    overflow: auto;
  }

  &.growOnFocus {
    min-height: 76px; // Approx 1 line + toolbar.

    [data-autopilot-system-redesign='on'] & {
      padding: 0;
    }
  }
}
